/**
 * Name-plus-parser shim. The web app navigates its bid workspace from this
 * module; the pane gates `navigate_bid` off for the Word surface and keeps
 * only what `tool-activity.tsx` needs to label a thread started on the web.
 */
import { asRecord, getStringValue, parseMaybeJson } from "@/agents-v2/utils/unknown";

export const BID_NAVIGATION_TOOL_NAME = "navigate_bid";

export type BidAgentNavigationRequest = {
  destination: string | null;
  view: string | null;
  sectionId: string | null;
  reason: string | null;
};

/**
 * Read a navigation request out of a tool call's args or result.
 * @param value - The raw args, args text or result.
 * @returns The request, or null when the value is not one.
 */
export const parseBidNavigationRequest = (
  value: unknown
): BidAgentNavigationRequest | null => {
  const record = asRecord(parseMaybeJson(value));
  const destination = getStringValue(record, "destination");
  const view = getStringValue(record, "view");
  if (!destination && !view) return null;
  return {
    destination,
    view,
    sectionId: getStringValue(record, "section_id"),
    reason: getStringValue(record, "reason")
  };
};
